module.exports = __webpack_public_path__ + "gs.svg?e0781d5f0aa876f21fb1689a754e6815";